<template>
  <Modal v-model="relatedProductsModal" :title="$t('key1005549')" width="1000" :transfer="false"
    class-name="commonModalStyles" :mask-closable="false" @on-visible-change="relatedProductsChange">
    <div class="flex flex-wrap align-items-center wid100P">
      <Input style="width:200px; margin-right: 20px;" v-model.trim="pageParams.productName" :placeholder="$t('key1000380')"/>
      <Input style="width:200px; margin-right: 20px;" v-model.trim="pageParams.ymsSpus" :placeholder="$t('key1000714')"/>
      <Select v-model="pageParams.zoneCode" transfer style="width:200px; margin-right: 20px;"
        :placeholder="$t('key1005548')" v-if="relatedProductsType === 'manufacturer'">
        <Option v-for="item in responsibleAreaList" :key="item.zoneCode" :value="item.zoneCode">{{ item.name }}</Option>
      </Select>
      <Button class="mr12" type="primary" @click="search">{{ $t('key1000011') }}</Button>
      <Button @click="reset">{{ $t('key1000109') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table-box mt14">
      <Table
        ref="tbableDom"
        highlight-row
        border
        max-height="480"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      style="text-align: right; margin: 20px 0;"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <template #footer>
      <Button class="mr15" type="primary" @click="relatedProductsModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {isJSON} from "@/utils/common";

export default {
  name: 'relatedProductsModal',
  mixins: [Mixin],
  props: {
    responsibleAreaList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      relatedProductsModal: false,
      pageParams: {
        productName: '',
        ymsSpus: '',
        zoneCode: null,
        pageNum: 1,
        pageSize: 15
      },
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 300,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let productName = '';
            if (name) {
              if (isJSON(name)) {
                let obj = JSON.parse(name);
                productName = obj[v.languagesVal]
              } else {
                productName = name;
              }
            }
            let imagePath = params.row.imagePath;
            let list = [
              v.tableImg(h, params, 'imagePath', imagePath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: productName,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695'),
          key: 'skuNumber',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'),
          renderHeader(h) {
            return h('div', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697')}(${v.currencyState})`);
          },
          key: 'suggestPrice',
          minWidth: 160,
          align: 'left',
          render(h, {row}) {
            const {maxSuggestPrice, minSuggestPrice} = row;
            let price = '0';
            if (maxSuggestPrice && minSuggestPrice) {
              price = maxSuggestPrice === minSuggestPrice
                ? maxSuggestPrice
                : `${minSuggestPrice} ~ ${maxSuggestPrice}`;
            } else {
              price = maxSuggestPrice || minSuggestPrice || '0';
            }
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005548'),
          key: 'associatedArea',
          minWidth: 120,
          align: 'center',
          render: (h, {row}) =>
            h('span',
              (row.zoneCodes || [])
                .map(code => v.responsibleAreaList.find(item => item.zoneCode === code)?.name || '')
                .filter(Boolean).join('、') || '-'
            )
        },
      ],
      tableColumns: [],
      tableData: [],
      total: 0,
      ymsCompliancePersonId: null,
      ymsManufacturerInfoId: null,
      relatedProductsType: null,
    }
  },
  computed: {
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initRelatedProductsData(type, id) {
      this.relatedProductsType = type;
      if (type === 'responsiblePerson') {
        this.ymsCompliancePersonId = id;
      } else {
        this.ymsManufacturerInfoId = id;
      }
      this.handleColumns();
      this.getList();
      this.relatedProductsModal = true;
    },
    // 搜索
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置筛选
    reset() {
      this.pageParams = {
        productName: '',
        ymsSpus: '',
        zoneCode: null,
        pageNum: 1,
        pageSize: 15
      };
    },
    // 获取商品数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.tableLoading = true;
      let obj = Object.assign({}, v.pageParams);
      let url = '';
      let query = {
        productName: obj.productName,
        ymsSpus: obj.ymsSpus ? [obj.ymsSpus] : [],
        pageNum: obj.pageNum,
        pageSize: obj.pageSize
      }
      if (v.relatedProductsType === 'responsiblePerson') {
        query.ymsCompliancePersonId = v.ymsCompliancePersonId;
        url = api.post_ymsCompliancePerson_queryCompliancePersonProductList;
      } else {
        query.ymsDistributorMerchantId = v.userInfo.merchantId;
        query.ymsManufacturerInfoId = v.ymsManufacturerInfoId;
        query.zoneCodes = obj.zoneCode ? [obj.zoneCode] : [];
        url = api.post_ymsManufacturerInfo_queryManufacturerProductList;
      }
      v.axios.post(url, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let list = data.list || [];
          if (list.length) {
            let ymsProductIds = [];
            list.forEach(item => {
              if (item.ymsProductId) {
                ymsProductIds.push(item.ymsProductId)
              }
            });
            if (ymsProductIds.length > 0) {
              let params = {
                ymsProductIds,
                distributorMerchantId: v.userInfo.merchantId,
                productTypes: ['1', '2', '3', '4', '5'],
                pageNum: 1,
                pageSize: obj.pageSize
              }
              v.axios.post(api.post_ymsProductInfo_api_query, params).then(response => {
                if (response.data.code === 0) {
                  let data = response.data.datas;
                  let newList = data.list || [];
                  let arr = list
                    .map(item => {
                      let newItem = newList.find(n => n.ymsProductId === item.ymsProductId);
                      return newItem ? Object.assign({}, item, newItem) : null;
                    }).filter(Boolean);
                  v.tableData = arr;
                  v.updateTableDom('tbableDom');
                }
              });
            }
          } else {
            v.tableData = list;
            v.updateTableDom('tbableDom');
          }
          v.total = data.total;
        } else {
          v.tableLoading = false;
        }
      });
    },
    // 监听弹窗
    relatedProductsChange(value) {
      if (!value) {
        this.reset();
        this.ymsCompliancePersonId = null;
        this.ymsManufacturerInfoId = null;
        this.tableData = [];
      }
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let hideKeyList = [];
      if (v.relatedProductsType === 'manufacturer') {
        v.tableColumns = v.originalColumns;
      } else {
        hideKeyList = ['associatedArea'];
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyList.includes(item.key)
        })
      }
      v.$forceUpdate();
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
};
</script>

<style lang="less">

</style>
